import { useEffect, useState } from "react";
import { NumericFormat } from "react-number-format";
import { getRGBFromXYZ } from "../../helpers/colorHelper";

interface Props {
  label?: string;
  placeholder: string;
  id?: string;
  defaultXYZ: any;
  dataField: string;
  rgbColorFieldName: string;
  formData: any;
  setStateMethod: any;
  disabled?: boolean;
}

export const XYZColorSelector = (props: Props) => {
  const [xyz, setXYZ] = useState({
    x: 0, y: 0, z: 0
  });

  const [rgb, setRGB] = useState<string>('');

  useEffect(() => {
    if (props.defaultXYZ) {
      setXYZ(props.defaultXYZ);

      setRGB(getRGBFromXYZ(props.defaultXYZ.x, props.defaultXYZ.y, props.defaultXYZ.z));
    }
  }, [props.defaultXYZ]);

  const onXYZChanged = (x, y, z) => {
    let newXYZ = { ...xyz };

    if (x) {
      newXYZ.x = parseFloat(x);
    }
    if (y) {
      newXYZ.y = parseFloat(y);
    }
    if (z) {
      newXYZ.z = parseFloat(z);
    }

    setXYZ(newXYZ);
    const rgb = getRGBFromXYZ(newXYZ.x, newXYZ.y, newXYZ.z);
    setRGB(rgb);

    props.formData[props.dataField] = newXYZ;
    props.formData[props.rgbColorFieldName] = rgb;
    if (props.setStateMethod) {
      props.setStateMethod({ ...props.formData });
    }
  };

  return (
    <>
      <div className="row">
        {props.label && (
          <label htmlFor={props.id} className="col-sm-3 col-form-label zvlabel">
            {props.label}
          </label>
        )}

        <div className="col-sm-9">
          <div style={{ display: "flex" }}>
            <NumericFormat
              value={xyz.x}
              decimalScale={3}
              className={`form-control`}
              disabled={props.disabled}
              onFocus={(event) => event.target.select()}
              onChange={(event) => {
                onXYZChanged(event.target.value, null, null);
              }}
            />
            <NumericFormat
              value={xyz.y}
              decimalScale={3}
              className={`form-control`}
              disabled={props.disabled}
              onFocus={(event) => event.target.select()}
              onChange={(event) => {
                onXYZChanged(null, event.target.value, null);
              }}
            />
            <NumericFormat
              value={xyz.z}
              decimalScale={3}
              className={`form-control`}
              disabled={props.disabled}
              onFocus={(event) => event.target.select()}
              onChange={(event) => {
                onXYZChanged(null, null, event.target.value);
              }}
            />
            <div
              className="colorPreview"
              style={{ backgroundColor: rgb }}
            ></div>
          </div>
        </div>
      </div>
    </>
  );
};
